import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "d-flex flex-column overflow-y-hidden",
      attrs: { "data-qa": "appointment-restrictions-modal-content" },
    },
    [
      _vm.lpuName
        ? _c(
            "div",
            {
              staticClass: "d-flex align-center py-1 mb-4",
              attrs: { "data-qa": "modal-content-lpu" },
            },
            [
              _c(
                VIcon,
                { staticClass: "mr-4", attrs: { color: "icon-secondary" } },
                [_vm._v("\n      ui-icon-clinic\n    ")]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "text-body-1 text-break text--text" }, [
                _vm._v(_vm._s(_vm.lpuName)),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "restrictionsDataListRef",
          staticClass: "custom-scroll overflow-y-auto text--text",
          attrs: { "data-qa": "modal-content-restrictions-data-list" },
        },
        _vm._l(
          _vm.restrictionsDataList,
          function ({ title, restrictions }, index) {
            return _c(
              "div",
              {
                key: index,
                class: { "mt-4": index !== 0 },
                attrs: {
                  "data-qa": "modal-content-restrictions-data-list-item",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "text-subtitle-1 text-break mb-1",
                    attrs: {
                      "data-qa":
                        "modal-content-restrictions-data-list-item-title",
                    },
                  },
                  [_vm._v("\n        " + _vm._s(title) + "\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    attrs: {
                      "data-qa":
                        "modal-content-restrictions-data-list-item-restrictions",
                    },
                  },
                  _vm._l(
                    restrictions,
                    function (restriction, indexRestriction) {
                      return _c(
                        "li",
                        {
                          key: indexRestriction,
                          staticClass: "text-body-1 text-break",
                          attrs: {
                            "data-qa":
                              "modal-content-restrictions-data-list-item-restrictions-item",
                          },
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(restriction) + "\n        "
                          ),
                        ]
                      )
                    }
                  ),
                  0
                ),
              ]
            )
          }
        ),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }